import { create } from "zustand";

// One-shot handoff for a new-thread caseId. The suggestion handler writes
// this synchronously before `aui.thread().append(...)`; the thread-list
// provider's `initialize()` consumes it synchronously during the
// POST /api/threads call. Bypasses the React commit + passive-effect cycle
// that `routeContextRef` syncing depends on — that cycle is not guaranteed
// to flush within a single `setTimeout(0)` macrotask, which used to drop
// the caseId for case-only suggestions on /default.
type PendingNewThreadCaseIdState = {
  caseId: string | null;
  set: (id: string | null) => void;
  consume: () => string | null;
};

export const usePendingNewThreadCaseIdStore = create<PendingNewThreadCaseIdState>((set, get) => ({
  caseId: null,
  set: (id) => set({ caseId: id }),
  consume: () => {
    const current = get().caseId;
    if (current !== null) set({ caseId: null });
    return current;
  },
}));
